import { Component, OnInit, Output, EventEmitter,ViewChild, TemplateRef, OnDestroy } from '@angular/core';
import { ApiService } from 'src/app/services/api.service';
import { AuthService } from 'src/app/services/auth.service';
import { marked } from 'marked';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { finalize, Subscription, take } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { UserService } from 'src/app/services/user.service';
import { environment } from 'src/environments/environment';
import { UtilsService } from 'src/app/services/utils.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';

@Component({
  selector: 'app-chat-bot',
  templateUrl: './chat-bot.component.html',
  styleUrls: ['./chat-bot.component.scss'],
})
export class ChatBotComponent implements OnInit, OnDestroy {

  isMinimized = false;
  isChatVisible = true;
  // initial greeting
  defaultMsg:any = { sender: 'assistant', message: 'Hi I’m Iris. How can I help you today?', timestamp: '', formatTime: '' };
  errMsg :any = { sender: 'assistant', message: 'Sorry, something went wrong. Please try again.',timestamp: '',formatTime: '' }
  messages: any[] = [];
  draftMessage: any[] = [];
  
  currentUser:any;
  sessionId : any;
  userMessage: string = '';
  chatHtml!: SafeHtml;
  loading: boolean = false;
  @Output() closeChatWindow = new EventEmitter<any>();
  private streamSub?: Subscription;
  @ViewChild('successDialog') successDialog!: TemplateRef<any>;
  userImg:any;
  chatForm!: FormGroup;
  isExpanded = false;
  disableMail: boolean = false; // After sending an email to the CSM, Disable the CSM button until the user asks a new question.

  constructor(
    private apiService: ApiService,
    private authService: AuthService,
    private sanitizer: DomSanitizer,
    private dialog: MatDialog,
    private userService:UserService,
    private utilsService: UtilsService,
    private router: Router
  ) {}

  ngOnInit(): void {
    
    this.chatForm = new FormGroup({
      message: new FormControl('', [Validators.required, Validators.minLength(1)])
    });
    
    this.authService.user.pipe(take(1)).subscribe((user) => {
      this.currentUser = user;
      this.loading = true;
      this.userService.personalInfo(this.currentUser?.id).pipe(take(1)).subscribe((res: any) => {          
          if (res.photo !== undefined)
              this.userImg = environment.usersServer + "/data/" + res.photo;
      })
      setTimeout(()=>{
        this.loading = false;
        const msg = {...this.defaultMsg, timestamp: new Date(), formatTime: this.convertTime(new Date())};
        this.messages = [msg];
        this.draftMessage = [msg];

      },500)
      
    });

    window.addEventListener('mousedown', this.handleMouseDown);
    window.addEventListener('mouseup', this.handleMouseUp);
  };

  ngOnDestroy(): void {
    window.removeEventListener('mousedown', this.handleMouseDown);
    window.removeEventListener('mouseup', this.handleMouseUp);
  }

  handleMouseDown = (event: MouseEvent) => {
    const target = event.target as HTMLElement;

    // Only activate when interacting with chat window
    if (target.closest('.chat-window')) {
      document.body.classList.add('chat-resizing');
    }
  };

  handleMouseUp = () => {
    document.body.classList.remove('chat-resizing');
  };

  toggleExpand() {
    this.isExpanded = !this.isExpanded;
  }

  goToTerms() {
    if (this.router.url !== '/termsofuse') {
      this.router.navigate(['/termsofuse']);
    }
  }

  onEnter(event: Event) {
    const keyboardEvent = event as KeyboardEvent;

    // Allow Ctrl + Enter → new line
    if (keyboardEvent.ctrlKey) {
      return;
    }
    event.preventDefault();
    event.stopPropagation();
    this.sendMessage(event);
  }



  sendMessage(event:any) {
    if (event) {
      event.preventDefault();
    }
    if (this.chatForm.invalid || this.loading) return;
    const messageText = this.chatForm.value.message.trim();
    if (!messageText) return;

    const now = new Date();

    // Add user message
    this.messages.push({ sender: 'user', message: messageText, timestamp: now, formatTime: this.convertTime(now) });
    this.draftMessage.push({ sender: 'user', message: messageText, timestamp: now, formatTime: this.convertTime(now) });
    this.chatForm.get('message')?.setValue('');
    this.loading = true;
    this.scrollToBottom(100);

    const payload = {
      user_id: this.currentUser?.id,
      session_id: this.sessionId || '',
      message: messageText
    };

    this.streamSub?.unsubscribe();

    this.streamSub = this.apiService.sendUserMessage(payload)
      .pipe(finalize(() => {
        this.loading = false;
        this.disableMail = false;
      }))
      .subscribe({
        next: (response) => {
          this.sessionId = response?.session_id;

          const html: any = marked(response.final_answer);
          const safeHtml = this.sanitizer.bypassSecurityTrustHtml(html);

          // Push bot message
          this.messages.push({ sender: 'assistant', message: safeHtml, timestamp: new Date(), formatTime: this.convertTime(new Date()) });
          this.draftMessage.push({ sender: 'assistant', message: response.final_answer, timestamp: new Date(), formatTime: this.convertTime(new Date()) });

          this.scrollToBottom(100);
        },
        error: () => {
          const msg = {...this.errMsg, timestamp: new Date(), formatTime: this.convertTime(new Date())};
          this.messages.push(msg);
          this.draftMessage.push(msg);
          this.scrollToBottom(100);
        }
      });
  }


  scrollToBottom(speedTime:number) {
    setTimeout(() => {
      const container = document.querySelector('.messages');
      if (container) {
      container.scrollTo({
        top: container.scrollHeight,
        behavior: 'smooth'
      });
    }
    }, speedTime);
  }

  toggleMinimize() {
    this.isMinimized = !this.isMinimized;
    if(!this.isMinimized) this.scrollToBottom(500);
  }

  clearChat() {
    if (!this.sessionId && this.messages.length === 1) return;
    this.streamSub?.unsubscribe();
    this.loading = false;
    let payload = {
      session_id : this.sessionId || '',
    }
    this.apiService.clearUserMessage(payload).subscribe({
      next: (response) => {
        this.sessionId = '';
        const msg = {...this.defaultMsg, timestamp: new Date(), formatTime: this.convertTime(new Date())};
        this.messages = [msg];
        this.draftMessage = [msg];
      },
      error: (err) => {
        // this.loading = false;
      },
    });
  }

  closeChat() {
    this.streamSub?.unsubscribe();
    this.messages = [];
    this.draftMessage = [];
    this.closeChatWindow.emit();
  }

  sendMail(){
    this.disableMail = true;
    let payload = {
      conversations : this.draftMessage
    }
    this.apiService.sendChatbotMail(payload).subscribe({
      next: (response) => {
        this.disableMail = true;
        this.dialog.open(this.successDialog, {
          width: '40%',
          backdropClass: 'blurred',
          disableClose: true
        });
      },
      error: (err) => {
        this.loading = false;
        this.disableMail = false;
      },
    });
  };

  convertTime(dateTime: any) {
    if (!dateTime) return null;
    return this.utilsService.convertUtcToLocal(dateTime, this.currentUser);
  };

}
